import DriverDashboard from "Layout/DriverDashboard";

const DriverNotifications = () => {
  return (
    <DriverDashboard title={"Notifications"} back={false}>
      Driver Notifications
      {/* <p>
        Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ad praesentium
        aliquam veniam repudiandae consequatur nam harum provident maiores
        consectetur aspernatur? Sunt neque labore soluta laudantium asperiores
        aut magni a maiores?
      </p> */}
    </DriverDashboard>
  );
};

export default DriverNotifications;
